import { ConfirmActionModal } from 'components/ui/modal';
import React from 'react';
import { withTranslation } from 'react-i18next';
function ConfirmAssignCarrierModal({ t, isOpen, onClose, onConfirm, shipment, brokerCarrierDriver, }) {
    function confirmAssignment() {
        onConfirm(shipment, brokerCarrierDriver);
        onClose();
    }
    return (React.createElement(ConfirmActionModal, { className: "w-4/5", isOpen: isOpen, title: t('ASSIGN'), onConfirm: confirmAssignment, onClose: onClose },
        React.createElement("div", null, t('ASSIGN_BROKER_CARRIER_WARNING_MESSAGE'))));
}
export default withTranslation()(ConfirmAssignCarrierModal);
